import React from "react";

import { AnimatedEllipsisProps } from "../types/AnimatedEllipsisProps";

const AnimatedEllipsis: React.FC<AnimatedEllipsisProps> = ({
  text,
  className = "",
}) => {
  // Split text by the … character to separate lines
  const parts = text.split("…");
  
  return (
    <div className={`text-center ${className}`}>
      <div className="flex flex-col gap-y-1">
        <div>
          <span>{parts[0]}</span>
          <style>{`
            @keyframes blink-dots {
              0%, 20% { content: '.'; }
              40% { content: '..'; }
              60%, 100% { content: '...'; }
            }
            .animated-dots::before {
              content: '.';
              animation: blink-dots 1.5s steps(1) infinite;
              display: inline;
              font-size: 1.25rem;
              line-height: 1;
            }
          `}</style>
          <span className="animated-dots" />
        </div>
        {parts[1] && <span>{parts[1]}</span>}
      </div>
    </div>
  );
};

export default AnimatedEllipsis;
